// import { useContext } from 'react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../';

interface IConversationPayload {
    "message_id": string,
    "message": {
      "id": string,
      "space_id": string,
      "conversation_id": string,
      "user_id": number,
      "created_timestamp": number,
      "status": string,
      "content": string,
      "auto_regenerate_count": number,
      "message_id": string
    },
    "conversation_id": string,
    "conversation": {
      "id": string,
      "space_id": string,
      "user_id": number,
      "created_timestamp": number,
      "last_updated_timestamp": number,
      "title": string
      "conversation_id": string
    }
}


interface IGenieState {
  oauthToken: string,
  isLoading: boolean,
  loadingMessage: string,
  isConversationOpen: boolean,
  question: string,
  conversationPayload?: IConversationPayload,
  firstAttachment?: any,
  followup: any,
  previousAttachmentId?: string,
  results: any[],
  workspaceId: string,
  conversationId: string,
  messageId: string,
  skipAttachmentPolling: boolean,
  spaceid: string
}

const initialState = {
  oauthToken: "",
  isLoading: false,
  loadingMessage: "",
  isConversationOpen: true,
  question: "",
  conversationPayload: undefined,
  firstAttachment: undefined,
  previousAttachmentId: undefined,
  followup: undefined,
  results: [],
  workspaceId: "",
  conversationId: "",
  messageId: "",
  skipAttachmentPolling: true,
  spaceid: ""
} as IGenieState

const genieSlice = createSlice({
  name: 'genie',
  initialState,
  reducers: {
    setOauthToken(state, action) {
      state.oauthToken = action.payload
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setQuestion(state, action: PayloadAction<string>) {
      state.question = action.payload
    },
    setConversationPayload(state, action: PayloadAction<IConversationPayload | undefined>) {
     state.conversationPayload = action.payload
    },
    setResults(state, action: PayloadAction<any>) {
      state.results.push(action.payload)
    },
    clearResults(state) {
      state.results = []
    },
    setFirstAttachment(state, action: PayloadAction<any>) {
      state.firstAttachment = action.payload
    },
    setPreviousAttachmentId(state, action: PayloadAction<string>) {
      state.previousAttachmentId = action.payload
    },
    setFollowup(state, action: PayloadAction<any>) {
      state.followup = action.payload
    },
    setIsConversationOpen(state, action: PayloadAction<boolean>) {
      state.isConversationOpen = action.payload
    },
    setLoadingMessage(state, action: PayloadAction<string>) {
      state.loadingMessage = action.payload
    },
    setWorkspaceId(state, action: PayloadAction<string>) {
      state.workspaceId = action.payload
    },
    setConversationId(state, action: PayloadAction<string>) {
      state.conversationId = action.payload
    },
    setMessageId(state, action: PayloadAction<string>) {
      state.messageId = action.payload
    },
    setSkipAttachmentPolling(state, action: PayloadAction<boolean>) {
      state.skipAttachmentPolling = action.payload
    },
    setSpaceId(state, action: PayloadAction<string>) {
      state.spaceid = action.payload
    }
  }
})

export default genieSlice.reducer
export const { setOauthToken, setIsLoading, setQuestion, setConversationPayload, 
  setResults, setFirstAttachment, setPreviousAttachmentId, setFollowup, 
  setIsConversationOpen, setLoadingMessage, clearResults, 
  setWorkspaceId, setSkipAttachmentPolling,
  setConversationId, setMessageId, setSpaceId
 } = genieSlice.actions
export const selectToken = (state: RootState) => state.genie.oauthToken;
export const selectIsLoading = (state: RootState) => state.genie.isLoading;
export const selectConversation = (state: RootState) => state.genie.question;
export const selectConversationPayload = (state: RootState) => state.genie.conversationPayload;
export const selectResults = (state: RootState) => state.genie.results;
export const selectQuestion = (state: RootState) => state.genie.question;
export const selectFirstAttachment = (state: RootState) => state.genie.firstAttachment;
export const selectPreviousAttachmentId = (state: RootState) => state.genie.previousAttachmentId;
export const selectFollowup = (state: RootState) => state.genie.followup;
export const selectIsConversationOpen = (state: RootState) => state.genie.isConversationOpen;
export const selectLoadingMessage = (state: RootState) => state.genie.loadingMessage;
export const selectWorkspaceId = (state: RootState) => state.genie.workspaceId;
export const selectSkipAttachmentPolling = (state: RootState) => state.genie.skipAttachmentPolling;
export const selectConversationId = (state: RootState) => state.genie.conversationId
export const selectMessageId = (state: RootState) => state.genie.messageId
export const selectSpaceId = (state: RootState) => state.genie.spaceid